var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"centered-flex"},[_c('div',{staticClass:"content main__content col-md-12"},[_c('div',{staticClass:"login-page guest-forms",attrs:{"id":"login-page"}},[_c('br'),_c('div',[_c(_setup.LoginFormBlock,{attrs:{"disable-redirect":false,"backurl":_setup.backUrl,"oauth":true}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }